const { makeStyles } = require("@mui/styles");
const useStyles = makeStyles(({
  formWidth: {
    width: "80%"
  }
}));

export { useStyles };